import { batchActions } from 'redux-batched-actions'
import { take, put, fork, call, takeEvery, takeLatest, actionChannel } from 'redux-saga/effects'
import { BEGIN, COMMIT, REVERT } from 'redux-optimist'
import _ from 'lodash'

let nextTransactionID = 0
export function * optimisticPut (action) {
  const transactionID = nextTransactionID++

  if (Array.isArray(action)) {
    action = batchActions(action)
  }

  yield put({
    ...action,
    optimist: { type: BEGIN, id: transactionID }
  })

  return {
    commit: function * () {
      yield put({
        type: COMMIT,
        optimist: { type: COMMIT, id: transactionID }
      })
    },
    revert: function * () {
      yield put({
        type: REVERT,
        optimist: { type: REVERT, id: transactionID }
      })
    }
  }
}

export function optimisticDispatch (dispatch, action) {
  const transactionID = nextTransactionID++

  if (Array.isArray(action)) {
    action = batchActions(action)
  }

  dispatch({
    ...action,
    optimist: { type: BEGIN, id: transactionID }
  })

  return {
    commit: function () {
      dispatch({
        type: COMMIT,
        optimist: { type: COMMIT, id: transactionID }
      })
    },
    revert: function () {
      dispatch({
        type: REVERT,
        optimist: { type: REVERT, id: transactionID }
      })
    }
  }
}

function queue (pattern, saga) {
  return fork(function * () {
    // 1- Create a channel for request actions
    const requestChan = yield actionChannel(pattern)
    while (true) {
      // 2- take from the channel
      const action = yield take(requestChan)
      // 3- Note that we're using a blocking call
      yield call(saga, action)
    }
  })
}

function debounceReduce (func, wait, combine) {
  var allargs,
    context,
    wrapper = _.debounce(function () {
      var args = allargs
      allargs = undefined
      func.apply(context, args)
    }, wait)
  return function () {
    context = this
    allargs = combine.apply(context, [allargs, Array.prototype.slice.call(arguments, 0)])
    wrapper()
  }
}

export const createSagasActions = (array) => {
  const sagas = []
  const actionCreators = {}

  array.forEach(data => {
    const element = {
      type: data[0],
      name: data[1],
      saga: data[2],
      options: data[3] || {}
    }

    sagas.push(element)

    if (element.options.reduce) {
      const d = debounceReduce(
        function (dispatch, action) {
          dispatch(action)
        },
        50,
        function (acc, args) {
          if (acc) {
            acc[1].payload = element.options.reduce(acc[1].payload, args[1].payload)
            return acc
          } else {
            return args
          }
        }
      )
      actionCreators[element.name] = (payload) => {
        return dispatch => d(
          dispatch,
          {
            type: element.type,
            payload: {
              ...payload
            }
          }
        )
      }
    } else {
      actionCreators[element.name] = (payload) => {
        return {
          type: element.type,
          payload: {
            ...payload
          }
        }
      }
    }
  })

  return {
    getSagas: (...args) => {
      return sagas.map(element => {
        let saga
        if (element.options.takeLatest) {
          saga = function * () { yield takeLatest(element.type, element.saga, ...args) }
        } else if (element.options.queue) {
          saga = function * () { yield queue(element.type, element.saga, ...args) }
        } else {
          saga = function * () { yield takeEvery(element.type, element.saga, ...args) }
        }

        return call(saga)
      })
    },
    actionCreators
  }
}
